import ProfileClient from '@atlaskit/profilecard/client';
var defaultClient = new ProfileClient({
  url: '/gateway/api/directory/graphql'
});
export var useProfileClient = function useProfileClient() {
  return defaultClient;
};